import { ActAsTypes } from "enums/actAsTypes.ts";
import { UserRoles } from "enums/userRoles.ts";

const AdminUserRoles: UserRoles[] = [
  UserRoles.OrganizationAdmin,
  UserRoles.OrganizationManager,
  UserRoles.LeagueAdmin,
  UserRoles.LeagueManager,
  UserRoles.CompetitionAdmin,
  UserRoles.CompetitionManager,
  UserRoles.SeasonAdmin,
  UserRoles.SeasonManager,
];

const TeamManagerUserRoles: UserRoles[] = [
  UserRoles.EntityGroupAdmin,
  UserRoles.EntityGroupManager,
  UserRoles.EntityManager,
];

const getActAsType = (userRole: UserRoles): ActAsTypes | undefined => {
  if (AdminUserRoles.includes(userRole)) {
    return ActAsTypes.Admin;
  }
  if (TeamManagerUserRoles.includes(userRole)) {
    return ActAsTypes.TeamManager;
  }
  return undefined;
};

export const getActAsTypes = (userRoles: string[]): ActAsTypes[] =>
  (userRoles || [])
    .map((role: string) => getActAsType(role as UserRoles))
    .filter((x: ActAsTypes | undefined) => x !== undefined);
